import { useMutation, useQueryClient } from "react-query";
import { retrySms, SMS_QUERY_KEYS } from "@/services/sms";
/** Mutation hook that retries a failed message and refreshes the patient's history. */
export function useRetrySms(patientId) {
  var queryClient = useQueryClient();
  return useMutation(function (messageId) {
    return retrySms(messageId);
  }, {
    onSuccess: function onSuccess() {
      queryClient.invalidateQueries(SMS_QUERY_KEYS.patientMessages(patientId));
    }
  });
}